<template>
  <div ref="layout" class="page-form">
    <h3 class="title">发货入口</h3>

    <div class="table-container">
      <TableCommon
        title="新要货系统已开票产品"
        :custome-config="() => vxeShowCustom('xTable')"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          :row-style="rowStyle"
        >
          <template #action="{ row }">
            <el-link type="primary" size="mini" @click="goApplyForGoodsEdit(row)">要货</el-link>
          </template>
          <template #infType="{ row }">
            <span>{{ filterDictionary(row.infType, 'A0022') }}</span>
          </template>
          <template #acceptUnitType="{ row }">
            <span>{{ filterDictionary(row.acceptUnitType, 'A0009') }}</span>
          </template>
          <template #zzfld000001="{ row }">
            <span>{{
              filterDictionary(row.zzfld000001, 'orgList', 'zzfld00001h', 'mc_short')
            }}</span>
          </template>
          <template #zZFLD00002Q="{ row }">
            <span>{{ filterDictionary(row.zZFLD00002Q, 'A0002') }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { Message } from 'element-ui'
import {
  apiGetUnFinishedInv
} from '@/api/applyForGoods/index'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'

// import ApplyForGoodsEdit from '../components/ApplyForGoodsEdit.vue'
import { filterDictionary } from '@/utils/index'
import { mapGetters } from 'vuex'
import { method } from 'lodash'

const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')

export default {
  components: {
    ClientSelect
  },
  data(){
    return {
      loading: false,
      conditions: {
        saleCenter: '',
        saleCenterView: '',
        customerCode: '',
        customerName: '',
        department: '',
        createdDate: ''
      },
      gridOptions: {
        buttons: [],
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'annual', title: '年度', width: 80 },
          { field: 'custName', title: '开票客户' },
          { field: 'orderCustName', title: '订单客户' },
         // { field: 'acceptUnitType', title: '客户类型' , slots: { default: 'acceptUnitType' }},
          { field: 'infType', title: '制票通知单类型', slots: { default: 'infType' }},
          { field: 'zZFLD00002Q', title: '销售计划类型', slots: { default: 'zZFLD00002Q' }},
          { field: 'zzfld000001TextView', title: '营销中心' },
          { field: 'productDesc', title: '产品名称' },
          {
            field: 'invoiceQty',
            title: '开票总量(件)',
            width: 100
          },
          { field: 'deliveryQty', title: '已发数量' },
          { field: 'availableQty', title: '剩余量' },
          { field: 'ticketDetailId', title: 'ticketDetailId',visible: false },
          { field: 'action', title: '操作', slots: { default: 'action' }}
        ],
        data: [],
        columnsFieldTypes: {
          zZFLD00002Q: 'select',
          action: 'action'
        }
      },
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0,
        loadingOptions: [{ target: '.table-block', text: '数据加载中...' }]
      },
      validRules: {},

    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.initDetail()
  },
  methods:{
    filterDictionary,
    goApplyForGoodsEdit(row) {
      this.$emit('changeActive', 'toGoods', row)
    },
    rowStyle({ row, rowIndex }) {
      if (row.isold - 0 === 1) {
        return {
          backgroundColor: 'rgb(229, 228, 226)',
        }
      }
    },
    // 处理分页事件table
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.initDetail()
    },
    async initDetail() {
      this.loading = true
      const { page, pagesize } = this.pagination
      const { customerCode, customerName } = this.conditions
      const params = {
        customerCode,
        customerName,
        page,
        pagesize,
        valid: true
      }
      try {
        const res = await apiGetUnFinishedInv(params)
        this.loading = false
        if (res?.status === 1) {
          const { Rows, Total, page } = res.data
          this.gridOptions.data = Rows
          this.pagination.totalCount = Total
          this.pagination.page = page
        }
      } catch (error) {
        //
      }
      this.loading = false
    },
  }
  
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/components/TerminalApply copy.vue